// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__PW1Mw","tooltip-arrow":"Tooltip_tooltip-arrow__UgqY9"};